import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { VesignDataService } from '../service/vesign-data.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-secondary-navbar',
  templateUrl: './secondary-navbar.component.html',
  styleUrls: ['./secondary-navbar.component.css']
})
export class SecondaryNavbarComponent implements OnInit {
  @ViewChild('myDivTakeAction') myDivTakeAction: ElementRef<HTMLElement>;
  @ViewChild('myDivViewComDocs') myDivViewComDocs: ElementRef<HTMLElement>;
  @ViewChild('myDivConslList') myDivConslList: ElementRef<HTMLElement>;
  @ViewChild('myDivInfo') myDivInfo: ElementRef<HTMLElement>;
  takeActionPagePendingDocCount:number=0;
  taskId: number = 0;
  gciId: number = 0;
  consltantListTabClass: string = "";
  takeActionTabClass: string = "";
  viewCompletedDocsTabClass: string = "";
  infoDocsTabClass: string = "";
  ViewCompletedDocsCount : string = "";
  DocCategoryViewCompletedDocs:string="";
  ViewComeletedPageDocsCount:number=0;
  tabValue:string="";
  constructor(private route: Router, private router: ActivatedRoute,private dataService: VesignDataService<any>) {
   // debugger
    this.route.events.pipe(
      filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        console.log(event.urlAfterRedirects.split("/")[1].split("?")[0])
        if (event.urlAfterRedirects.split("/")[1].split("?")[0] == "takeaction") {
          let el: HTMLElement = this.myDivTakeAction.nativeElement;
          el.click();
        }
        else if (event.urlAfterRedirects.split("/")[1].split("?")[0] == "viewcompleteddocs") {
          let el: HTMLElement = this.myDivViewComDocs.nativeElement;
          el.click();
        }
        else if (event.urlAfterRedirects.split("/")[1].split("?")[0] == "viewinformationdocs") {
          let el: HTMLElement = this.myDivInfo.nativeElement;
          el.click();
        }
        else if (event.urlAfterRedirects.split("/")[1].split("?")[0] == "consltantlist") {
          let el: HTMLElement = this.myDivConslList.nativeElement;
          el.click();
        }
        else {
          this.RedirectTakeAction();
        }

      }, error => console.log(error));
  }

  ngOnInit(): void {
    this.dataService.TakeActionCount$.subscribe((value)=>{
    this.takeActionPagePendingDocCount=value;
    });

    this.dataService.ViewVCompletedDocsCount$.subscribe((value)=>{
      this.ViewComeletedPageDocsCount=value;  
      });
     
  }
  RedirectConsultantList() {
    //debugger
    this.tabValue="one"
    this.consltantListTabClass = "sn_item gen-tab active";
    this.takeActionTabClass = "sn_item gen-tab";
    this.viewCompletedDocsTabClass = "sn_item gen-tab";
    this.infoDocsTabClass = "sn_item gen-tab";
    this.route.navigate(["/consltantlist"], { queryParams: { taskId: this.taskId }, queryParamsHandling: 'preserve' });
  }
  RedirectTakeAction() {
    this.consltantListTabClass = "sn_item gen-tab";
    this.takeActionTabClass = "sn_item gen-tab active";
    this.viewCompletedDocsTabClass = "sn_item gen-tab";
    this.infoDocsTabClass = "sn_item gen-tab";
    this.route.navigate(["/takeaction"], { queryParams: { taskId: this.taskId }, queryParamsHandling: 'preserve' });
  }
  RedirectViewDocs() {
    this.consltantListTabClass = "sn_item gen-tab";
    this.takeActionTabClass = "sn_item gen-tab";
    this.viewCompletedDocsTabClass = "sn_item gen-tab active";
    this.infoDocsTabClass = "sn_item gen-tab";
    this.route.navigate(["/viewcompleteddocs"], { queryParams: { taskId: this.taskId }, queryParamsHandling: 'preserve' });
  }
  RedirectInfoDocs() {
    this.consltantListTabClass = "sn_item gen-tab";
    this.takeActionTabClass = "sn_item gen-tab";
    this.viewCompletedDocsTabClass = "sn_item gen-tab";
    this.infoDocsTabClass = "sn_item gen-tab active";
    this.route.navigate(["/viewinformationdocs"], { queryParams: { taskId: this.taskId }, queryParamsHandling: 'preserve' });
  }
}
